import { buildSelectedTree } from './ip-entries-tree.mapper'
import { TreeNode } from 'primeng/api'
import { inject, Injectable } from '@angular/core'
import { IPJournalCloneForm } from './ip-journal-clone-form.model'
import { FeathersService } from '../../../../../services/feathers.service'

@Injectable({ providedIn: 'root' })
export class IpJournalCopyFormService {
  private feathers = inject(FeathersService)

  async saveFromTree(params: { clientIds: number[]; tree: TreeNode[] }): Promise<IPJournalCloneForm> {
    const payload: Partial<IPJournalCloneForm> = {
      clientIds: params.clientIds,
      IPEntriesSelect: buildSelectedTree(params.tree),
    }

    return await this.feathers.createWithFactory(IPJournalCloneForm as any, payload)
  }
}
